import { useState, useEffect } from 'react';
import { tournamentService, TournamentOption } from '../services/tournaments';

export const useTournaments = () => {
  const [tournaments, setTournaments] = useState<TournamentOption[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTournaments = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const data = await tournamentService.getTournaments();
        setTournaments(data);
      } catch (err) {
        setError('Error fetching tournaments');
        console.error('Error in useTournaments:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchTournaments();
  }, []);

  return { tournaments, loading, error };
};

export const useTournamentDetails = (tournamentId: string | undefined) => {
  const [tournament, setTournament] = useState<TournamentOption | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!tournamentId) {
      setTournament(null);
      setLoading(false);
      return;
    }

    const fetchTournamentDetails = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const data = await tournamentService.getTournamentDetails(tournamentId);
        setTournament(data);
      } catch (err) {
        setError('Error fetching tournament details');
        console.error('Error in useTournamentDetails:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchTournamentDetails();
  }, [tournamentId]);

  return { tournament, loading, error };
};
